import {create} from 'zustand';
import type {UseCurrentValueInputTypingStoreProps} from './types';

const useCurrentValueInputTypingStore = create<UseCurrentValueInputTypingStoreProps>(set => ({
	currentValueInputTyping: '',
	setCurrentValueInputTyping: (value: string) => set({currentValueInputTyping: value}),
}));

export {useCurrentValueInputTypingStore};
